var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_5919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8336 6.66675V13.3334C10.8336 13.9965 10.5702 14.6323 10.1013 15.1012C9.6325 15.57 8.99662 15.8334 8.33358 15.8334H6.52524C6.32866 16.3897 5.94175 16.8585 5.43291 17.157C4.92406 17.4556 4.32606 17.5647 3.74459 17.4649C3.16312 17.3652 2.63562 17.0631 2.25535 16.6121C1.87507 16.161 1.6665 15.59 1.6665 15.0001C1.6665 14.4101 1.87507 13.8392 2.25535 13.3881C2.63562 12.9371 3.16312 12.635 3.74459 12.5352C4.32606 12.4355 4.92406 12.5446 5.43291 12.8431C5.94175 13.1417 6.32866 13.6105 6.52524 14.1667H8.33358C8.55459 14.1667 8.76655 14.079 8.92283 13.9227C9.07911 13.7664 9.16691 13.5544 9.16691 13.3334V6.66675C9.16691 6.00371 9.4303 5.36782 9.89914 4.89898C10.368 4.43014 11.0039 4.16675 11.6669 4.16675H14.1669V1.66675L18.3336 5.00008L14.1669 8.33341V5.83341H11.6669C11.4459 5.83341 11.2339 5.92121 11.0777 6.07749C10.9214 6.23377 10.8336 6.44573 10.8336 6.66675Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_5919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.553ab984.svg";
export { ForwardRef as ReactComponent };